import { render, staticRenderFns } from "./TaskTraceViewer.vue?vue&type=template&id=bedddbbc&scoped=true"
import script from "./TaskTraceViewer.vue?vue&type=script&lang=js"
export * from "./TaskTraceViewer.vue?vue&type=script&lang=js"
import style0 from "./TaskTraceViewer.vue?vue&type=style&index=0&id=bedddbbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedddbbc",
  null
  
)

export default component.exports